import { section } from '@/neon';
import isMobile from 'is-mobile';

const ei = {
  get: () => JSON.parse(localStorage.getItem('exitIntent')),
  set: val => localStorage.setItem('exitIntent', val),
};

section('exit-intent', {
  onLoad() {
    this.closeBtn = this.container.querySelector('[data-close-icon]');
    const mobileTimeout = parseInt(this.container.dataset.mobileLandingTimeout);

    const mouseLeave = e => {
      if (!e.relatedTarget && !e.toElement) {
        this.showPopup();
        document.body.removeEventListener('mouseout', mouseLeave);
      }
    };

    const close = e => {
      e.preventDefault();
      this.hidePopup();
      ei.set(true);
    };

    if (!ei.get()) {
      if (isMobile()) {
        setTimeout(() => {
          this.showPopup();
        }, mobileTimeout);
      } else {
        document.body.addEventListener('mouseout', mouseLeave);
      }
      this.closeBtn.addEventListener('click', close);
      this.container.addEventListener('keyup', close);
    }
  },

  showPopup() {
    this.container.classList.add('animating');
    setTimeout(() => {
      this.container.classList.add('visible');
    }, 250);
  },

  hidePopup() {
    this.container.classList.remove('visible');
    this.container.classList.add('hidden');
    setTimeout(() => {
      this.container.classList.remove('animating');
    }, 250);
  },

  onSelect() {
    this.showPopup();
  },

  onDeselect() {
    this.hidePopup();
  },

  onUnload() {
    this.closeBtn.removeEventListener('click', close);
    this.container.removeEventListener('keyup', close);
  },
});
